import React from 'react';
import * as Survey from 'survey-react';
import 'survey-react/modern.css';
import { json } from './data.json'

Survey.StylesManager.applyTheme('modern');

export function Third() {


  const survey = new Survey.Model(json);
  survey.locale = 'ru';

  // survey.onTextMarkdown.add(function (survey, options) {
  //   options.html = options.text;
  // });

  survey.onComplete.add(async function (sender) {
    const surveyData = sender.data;
    console.log('surveyData', JSON.stringify(surveyData, null, 2))
    try {
      const response = await fetch('/api/questions/data/third', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          surveyData,
        }),
      });
      const answer = await response.json();
      console.log(answer);
    } catch (err) {
      console.log(err);
    }
  });

  // survey.checkErrorsMode = 'onValueChanged';
  survey.completeText = 'Сохранить';

  return <Survey.Survey model={survey} />;
}


